import { clientIdSelector } from 'common/redux/selectors/sessionSelector';
import {
    activeTeamIdsSelector,
    homebaseIdQuerySelector,
    homebaseOptionIdsQuerySelector
} from 'common/redux/selectors/queryParamsSelectors';
import * as Immutable from 'immutable';
import { createSelector } from 'reselect';
import { personnelTeamsSelector } from 'common/redux/selectors/personnelTeamsSelector';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';

export const getAllHomebases = (state, props) => {
    const clientId = clientIdSelector(state, props);
    return state.homebase.getIn(['records', clientId], Immutable.List());
};

export const getHomebasesIfPresent = (state, props) => {
    const clientId = clientIdSelector(state, props);
    return state.homebase.getIn(['records', clientId], null);
};

export const getHomebaseFromQuery = createSelector(
    [getHomebasesIfPresent, homebaseIdQuerySelector],
    (homebases, homebaseId) => {
        if (!homebases) {
            return null;
        }
        const matchingHomebase = homebases.find(
            homebase => homebase.id === homebaseId
        );
        return matchingHomebase;
    }
);

export const getHomebaseOptionsFromQuery = createSelector(
    [getHomebasesIfPresent, homebaseOptionIdsQuerySelector],
    (homebases, homebaseOptionIds) => {
        const homebaseIds = homebaseOptionIds.split(',');
        if (!homebases) {
            return null;
        }
        const selectedHomebaseOptions = [];
        homebaseIds.forEach(homebaseId => {
            const matchingHomebase = homebases.find(
                homebase => homebase.id === homebaseId
            );
            if (matchingHomebase) {
                selectedHomebaseOptions.push(matchingHomebase);
            }
        });
        return selectedHomebaseOptions;
    }
);

export const isFetchHomebaseInProgress = createSelector(
    [clientIdSelector, state => state.homebase],
    (clientId, homebaseState) => {
        return homebaseState.getIn([clientId, 'isFetchHomebaseInProgress']);
    }
);

export const getHomebasesByTeamIds = createSelector(
    [personnelTeamsSelector, getAllHomebases, activeTeamIdsSelector],
    (teams, homebases, selectedTeamIds) => {
        let selectedTeams = Immutable.Set();
        let teamsSet = Immutable.Set();
        if (teams && teams.size !== 0) {
            teamsSet = teams.map(team => team.get('teamId')).toSet();
        }
        if (isEmpty(selectedTeamIds)) {
            selectedTeams = selectedTeams.concat(teamsSet);
        } else {
            selectedTeams = reduce(
                selectedTeamIds,
                (result, teamId) => {
                    if (teamsSet.has(teamId)) {
                        return result.add(teamId);
                    }
                    return result;
                },
                Immutable.Set()
            );
        }
        if (selectedTeams.size !== 0) {
            return homebases.filter(homebase => {
                return (
                    homebase.teams.findIndex(homebaseTeam =>
                        selectedTeams.has(homebaseTeam.teamId)
                    ) !== -1
                );
            });
        }
        return Immutable.List();
    }
);

export default getAllHomebases;
